import { useState } from "react"

import { Link, useParams } from "react-router-dom"

import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"

import { useCheckList } from "./CheckListContext"
import { useScenarioType } from "../ScenarioTypeContext"

import BreadCrumbs from "../Breadcrumbs"

import ButtonBar from "./ButtonBar"
import DeleteButton from "./DeleteButton"
import ReadOnlyField from "./ReadOnlyField"
import SaveChecklistButton from "./SaveChecklistButton"
import TextInput from "./TextInput"

import { getChecklistBC } from "../urls"

const INITIAL_STATE = {
    newID: "",
    newLabel: ""
}

const PhaseList = () => {
    const params = useParams()
    const {scenarioType} = useScenarioType()
    const {getRec, uniqueIDs, uniqueLabels, insertRec, hier} = useCheckList()
    const [state, setState] = useState(INITIAL_STATE)
    const [errMsg, setErrMsg] = useState("")

    const changeHandler = (event) => {
        const {id, value} = event.target
        setState(prevState => Object.assign({}, prevState, {[id]: value}))
    }

    const addPhase = (event) => {
        event.preventDefault()
        if ("" === state.newID) {
            setErrMsg("Please enter an ID")
        } else if ("" === state.newLabel) {
            setErrMsg("Please enter a label")
        } else if (uniqueIDs.includes(state.newID)) {
            setErrMsg("id is not unique")
        } else if (uniqueLabels.includes(state.newLabel)) {
            setErrMsg("label is not unique")
        } else {
            setErrMsg("")
            const newRec = {
                id: state.newID,
                type: MDB_TYPES.PHASE,
                label: state.newLabel,
            }
            const index = hier[hier.length-1].lastIndex + 1
            // console.log("i will add at", index, newRec)
            insertRec(newRec, index)
            setState(INITIAL_STATE)
        }
    }

    const getPhaseHeading = (ctx, i) => {
        const rec = getRec(ctx)
        return (
            <>
                <td><ButtonBar rec={rec} /></td>
                <td><Link to={`/scenario-type/${scenarioType.id}/checklist/phase/${i}`}>edit</Link></td>
                <td><ReadOnlyField rec={rec} fld="id" size="40" /></td>
                <td><TextInput rec={rec} fld="label" size="80" unique={true}/></td>
                <td><DeleteButton rec={rec} /></td>
            </>
        )
    }

    return (
        <>
            <BreadCrumbs
                crumbs={[getChecklistBC(params)]}
            />
            <SaveChecklistButton />
            <table>
                <colgroup>
                    <col span="1" style={{width: "5%"}}/>
                    <col span="1" style={{width: "5%"}}/>
                    <col span="1" style={{width: "40%"}}/>
                    <col span="1" style={{width: "45%"}}/>
                    <col span="1" style={{width: "5%"}}/>
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>ID</th>
                        <th>Label</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {hier.map((ctx, i) =>
                        <tr key={ctx.id}>
                            {getPhaseHeading(ctx, i)}
                        </tr>
                    )}
                </tbody>
            </table>
            <hr/>
            <div>
                Add new Section: &nbsp;
                <b>ID: </b> <input type="text" id="newID" value={state.newID} autoComplete="off" onChange={changeHandler} />
                <b> Label: </b> <input type="text" id="newLabel" value={state.newLabel}  autoComplete="off" onChange={changeHandler} />
                <button type="button" className="add-btn" onClick={addPhase} > + </button>
            </div>
            <div className={"" === errMsg && "hidden"}>
                {errMsg}
            </div>
            <SaveChecklistButton />
        </>
    )
}

export default PhaseList